import { useLang } from 'hooks/lang';

import { anyOverlayEscape, Button, Modal } from 'components/Blocks';
import { DollarBillIcon } from 'components/Icons';

import { DiscountRequestTypeSelect } from 'pages/Invoice/components';
import { ProjectInvoiceDiscount } from 'entities';
import { DecimalInput } from 'components/Inputs';
import { getID } from 'utils/id';

interface ChooseValueModalProps {
  type: ProjectInvoiceDiscount['type'];

  update: (p: { type: ProjectInvoiceDiscount['type']; newValue: string }) => void;

  value: string;

  hasError: boolean;
}

export function ChooseValueModal({ type, update, value, hasError }: ChooseValueModalProps) {
  const { t } = useLang();

  return (
    <Modal
      title={t('choose-discount-value')}
      width="min(90vw, 560px)"
      gap="6"
      trigger={
        <Button variant="ghost" className="h-auto py-0.5">
          <DollarBillIcon />
          {t('choose-discount-value')}
        </Button>
      }
    >
      <DiscountRequestTypeSelect
        update={(data) => update({ ...data, newValue: value })}
        type={type}
      />

      <DecimalInput
        onChangeDirect={(newValue) => update({ type, newValue })}
        value={value}
        // avoid chrome autocomplete
        name={`disc-${getID()}`}
        placeholder={`${t('value')} %`}
        className={hasError ? 'border-destructive' : ''}
      />

      <Button disabled={hasError} onClick={anyOverlayEscape}>
        <DollarBillIcon />
        Salvar
      </Button>
    </Modal>
  );
}
